import React, {FunctionComponent, useEffect, useState} from 'react';
import {MerklisteProduktKarte} from '@juris/api-gen';
import {useMerklisteContext} from 'Context';

interface ProduktItemProps extends MerklisteProduktKarte {
}

export const ProduktItem: FunctionComponent<ProduktItemProps> = ({
                                                                     link,
                                                                     imageSource,
                                                                     imageAlt,
                                                                     title,
                                                                     subTitle,
                                                                     price,
                                                                     cmsId,
                                                                     tooltipText,
                                                                     orderButtons,
                                                                     testButtons,
                                                                     orderProductid,
                                                                     testProductid
                                                                      }) => {
    const {deleteItem} = useMerklisteContext();
    const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
        if (open) {
            const windowClickHandler = () => setOpen(false);
            window.addEventListener('click', windowClickHandler);

            return () => window.removeEventListener('click', windowClickHandler);
        }
    }, [open, setOpen]);

    return (
        <div className='bookmark-overview-item'>
            <div className='bookmark-overview-item__visual'>
                <picture className='picture'>
                    <a href={link}>
                        <img src={imageSource} alt={imageAlt} loading='lazy'/>
                    </a>
                </picture>
            </div>
            <div className='bookmark-overview-item__textblock'>
                <div className='textblock'>
                    <h3>{title}</h3>
                    <p>{subTitle}</p>
                    <a href={link} className='text-icon-link text-icon-link--link'>
                        <span className='text-icon-link__icon'/>
                        <span className='text-icon-link__text'>zum Produkt</span>
                    </a>
                </div>
            </div>
            <div className='bookmark-overview-item__price'>
                <div className='product-price'>
                    <span className='product-price__single'>
                        {price} €
                        <div className='product-price__single-subline'
                             {...(!!tooltipText ? {'data-tooltip': true} : {})}
                             onClick={() => setOpen(true)}>
                            {!!tooltipText && <span className='icon_error-circle_alt'/>}
                            <span>mtl. 1. Nutzer</span>
                            {!!tooltipText && (
                                <div className='product-price__price-tooltip'
                                     data-tooltip-content={true}
                                     data-tooltip-open={open}>
                                    <p dangerouslySetInnerHTML={{__html: tooltipText}}/>
                                </div>
                            )}
                        </div>
                    </span>
                </div>
            </div>
            <div className='bookmark-overview-item__buttons'>
                { testProductid &&
                    (<button className="cta-button cta-button--button-red"
                               data-type="productOverlayButton"
                               data-product-id={testProductid}
                               type="button">30 Tage testen</button>)
                }
                { orderProductid &&
                    (<button className="cta-button cta-button--button-white"
                               data-type="productOverlayButton"
                               data-product-id={orderProductid}
                               type="button">Jetzt kaufen</button>)
                }
            </div>
            <div className='bookmark-overview-item__actions'>
                <div className='bookmark-flyout-item__remove'>
                    <span className='text-icon-link text-icon-link--trash'
                          style={{cursor: 'pointer'}}
                          onClick={() => !!cmsId && deleteItem(cmsId)}>
                        <span className='text-icon-link__icon'/>
                        <span className='text-icon-link__text'>von Merkliste entfernen</span>
                    </span>
                </div>
            </div>
        </div>
    );
};